export const queryKeys = {
  sessionConfig: ['session-config'] as const,
  me: ['me'] as const,
  users: (params?: object) => ['users', params] as const,
  invites: ['invites'] as const,
  projects: (params?: object) => ['projects', params] as const,
  project: (id: string) => ['project', id] as const,
  tickets: (projectId: string, params?: object) =>
    ['tickets', projectId, params] as const,
  whatsOnDeck: ['whats-on-deck'] as const,
  risk: (projectId: string) => ['risk', projectId] as const,
  riskHistory: (projectId: string, days?: number) =>
    ['risk-history', projectId, days] as const,
  settings: ['settings'] as const,
  integrations: ['integrations'] as const,
  integrationHealth: ['integration-health'] as const,
  integrationResources: (provider: string) => ['integration-resources', provider] as const,
  personalIntegrations: ['personal-integrations'] as const,
  personalGoogleIngestedContent: ['personal-google-ingested-content'] as const,
  goals: ['goals'] as const,
  actionStats: ['action-stats'] as const,
  dateSlips: ['date-slips'] as const,
  messagingCoverage: ['messaging-coverage'] as const,
  // Persona-scoped — each functional role has its own briefing cache
  // document server-side, so the query key must carry the role too or
  // TanStack Query will serve one persona's briefing to another after a
  // persona switch. See useEffectiveRole().
  todayBriefing: (role: string) => ['today-briefing', role] as const,
} as const;
